module.exports = __webpack_public_path__ + "media/הפסקה.9a92fff6.mp3";